<template>
  <Tippy
    ref="tippyRef"
    v-bind="$attrs"
    :theme="theme"
    :arrow="arrowAttr"
  >
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps" />
    </template>
  </Tippy>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { Tippy } from 'vue-tippy';

const props = defineProps({
  light: { type: Boolean, default: false },
  arrow: { type: Boolean, default: true }
});

const tippyRef = ref();
const theme = computed(() => (props.light ? 'light' : 'dark'));

const arrowSvg = `<svg width="16" height="8" viewBox="0 0 16 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 8L16 8L9.41421 1.41421C8.63317 0.633164 7.36684 0.633164 6.58579 1.41421L0 8Z"/>
  </svg>`;
const arrowAttr = computed(() => (props.arrow ? arrowSvg : false));

defineExpose({ tippyRef });
</script>

<style lang="postcss" scoped>
@import 'tippy.js/dist/tippy.css';
@import 'tippy.js/dist/svg-arrow.css';

.tippy-box {
  @apply bg-transparent right-[-5px];
}

.tippy-content {
  @apply max-w-[400px] rounded-8 p-12 text-12;
}

.tippy-svg-arrow {
  @apply ml-[-3px];
}

[data-theme='dark'] {
  .tippy-box {
    filter: drop-shadow(0px 0px 1px #3C4353) drop-shadow(0px 0px 4px #242A38);
  }

  .tippy-content {
    @apply bg-[#19191C] text-white; 
  }

  .tippy-svg-arrow {
    svg {
      @apply fill-[#19191C];
    }
  }
}

[data-theme='light'] {
  .tippy-box {
    filter: drop-shadow(0px 0px 1px #e7eaee) drop-shadow(0px 0px 4px #C3C9D5);
  }

  .tippy-content {
    @apply bg-white text-neutral-900;
  }

  .tippy-svg-arrow {
    svg {
      @apply fill-white;
    }
  }
}
</style>
